import { render, staticRenderFns } from "./createEventFailed.vue?vue&type=template&id=6744f2d4&scoped=true"
import script from "./createEventFailed.vue?vue&type=script&lang=js"
export * from "./createEventFailed.vue?vue&type=script&lang=js"
import style0 from "./createEventFailed.vue?vue&type=style&index=0&id=6744f2d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744f2d4",
  null
  
)

export default component.exports